import React, { useState, useEffect } from 'react'
import Prismic from 'prismic-javascript'
import Root from 'pages/Root'
import Footer from 'organisms/Footer'
import client from 'api/prismicClient'
import Container from 'atoms/layout/Container'
import Header from 'organisms/Header'
import EventCardList from 'pages/events/EventCardList'

export default function Events () {
  const [doc, setDoc] = useState<any>([])
  useEffect(() => {
    (async () => {
      const response = await client.query(
        Prismic.Predicates.at('document.type', 'events'),
        { orderings: '[my.events.date desc]' })
      console.log(response)
      setDoc(response.results)
    })()
  })

  return (
    <Root>
      <Header/>
      <Container>
        <EventCardList list={doc}/>
      </Container>
      <Footer/>
    </Root>
  )
}
